export default __webpack_public_path__ + "static/media/manage-accounts.1f956535.svg";